import { Box, Typography } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import React, { Component } from 'react';
import Dialog from '../../../../../commonModules/interface/Dialog';
import InputText from '../../../../../commonModules/interface/form-input-inline';


class StockageZone extends Component {
    state = { 
        product_mag: "",
        product_zone: "",
        product_section: "",
        product_level: "",
        errors:{
            product_mag: "",
            product_zone: "",
            product_section: "",
            product_level: "",

        }
     }
    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }
    render() {
        const {product_level, product_section, product_zone, product_mag} = this.state;
        return (
            <Dialog
                title="Zone de Stockage"
                block={true}
                close={this.props.handleClose}
            >
                <Box p={1}>
                    <Alert severity="info">
                        <AlertTitle>Code de Stockage</AlertTitle>
                        <Typography variant="h5">{product_mag + "-" + product_zone + product_section + "-0" + product_level}</Typography>
                    </Alert>
                    <InputText
                        name="product_mag"
                        title="Magasin"
                        value={this.state.product_mag}
                        error={this.state.errors.product_mag}
                        change={this.handleChange}
                    />
                    <InputText
                        name="product_zone"
                        title="Zone"
                        value={this.state.product_zone}
                        error={this.state.errors.product_zone}
                        change={this.handleChange}
                    />
                    <InputText
                        name="product_section"
                        title="Section"
                        value={this.state.product_section}
                        error={this.state.errors.product_section}
                        change={this.handleChange}
                    />
                    <InputText
                        name="product_level"
                        title="Etage"
                        value={this.state.product_etage}
                        error={this.state.errors.product_etage}
                        change={this.handleChange}
                    />
                </Box>
            </Dialog>
        );
    }
}

export default StockageZone;